<ng-template #content_config_ui_device let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}">
        <div class="side_popup_header">
            <span>{{localService.languageContent.table.action + ' - ' + title}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
        <div class="side_popup_body" style="max-height: calc(100vh - 130px);">
            <div *ngIf="item">
                <div class="row">
                    <div class="col-12">
                        <div>
                            <label for="device_name">Device Name *</label>
                        </div>
                        <div>
                            <input type="text" id="device_name" [(ngModel)]="item.Title">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <label style="font-weight: normal; margin-left: 15px;">
                            <input type="checkbox" [(ngModel)]="item.IsActive" />
                            <span class="normal_color">Is Active?</span>
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div>
                            <label>OS Type *</label>
                        </div>
                        <div>
                            <ngx-select style="position: relative;    width: calc(100% - 20px);" *ngIf="osTypes"
                                [(ngModel)]="item.DeviceOs" [optionValueField]="'key'" [optionTextField]="'value'"
                                (select)="onOsSelected()" [items]="osTypes" [noAutoComplete]="true">
                            </ngx-select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div>
                            <label>Billing Mode *</label>
                        </div>
                        <div>
                            <ngx-select style="position: relative; width: calc(100% - 20px);" *ngIf="osTypes"
                                [(ngModel)]="item.BillingMode" [optionValueField]="'key'" [optionTextField]="'value'"
                                [items]="billingModes" [noAutoComplete]="true">
                            </ngx-select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div>
                        <label>Direct Print Url :</label>
                    </div>
                    <div>
                        <input type="text" [(ngModel)]="item.DirectPrintUrl" />
                    </div>
                </div>
                <div class="row">
                    <div>
                        <label>Direct Weigh Machine Url :</label>
                    </div>
                    <div>
                        <input type="text" [(ngModel)]="item.DirectWeightMachineUrl" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div>
                            <label>QR Label Printer</label>
                        </div>
                        <div>
                            <ngx-select style="position: relative; width: calc(100% - 20px);" *ngIf="printers"
                                [placeholder]="'Select qr label printer'" [allowClear]="true"
                                [(ngModel)]="item.QrLabelPrinterNameId" [optionValueField]="'key'"
                                [optionTextField]="'v2'" [items]="printers" [noAutoComplete]="true">
                            </ngx-select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div>
                            <label>Network Weigh Machine</label>
                        </div>
                        <div>
                            <ngx-select style="position: relative;    width: calc(100% - 20px);" *ngIf="weightMachines"
                                [placeholder]="'Select network weight machine'" [allowClear]="true"
                                [(ngModel)]="item.NetworkWeightMachineNameId" [optionValueField]="'Id'"
                                [optionTextField]="'WeightMachineName'" [items]="weightMachines"
                                [noAutoComplete]="true">
                            </ngx-select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <label style="font-weight: normal; margin-left: 15px;">
                            <input type="checkbox" [(ngModel)]="item.IsEnableSilentPrint" />
                            <span class="normal_color">Enable Silent Print</span>
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <label style="font-weight: normal; margin-left: 15px;">
                            <input type="checkbox" [(ngModel)]="item.IsEnableWeightMachine" />
                            <span class="normal_color">Enable Weight Machine</span>
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <label style="font-weight: normal; margin-left: 15px;">
                            <input type="checkbox" [(ngModel)]="item.IsCompactViewInBillingMode" />
                            <span class="normal_color">Enable Compact View In Billing Mode</span>
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <label style="font-weight: normal; margin-left: 15px;">
                            <input type="checkbox" [(ngModel)]="item.IsCompactViewInSalesReport" />
                            <span class="normal_color">Enable Compact View In Sales Report</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="side_popup_footer">
            <div class="row">
                <div class="col-12">
                    <button type="button" class="btn btn-primary" (click)="onAction(1)">{{id && id.length > 5 ?
                        localService.languageContent.common.save :
                        localService.languageContent.common.create}}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>